import {AxiosCall} from '../axios';
import {environment} from '../environment/environment';
import {PAYMENT_TYPES_ENUM} from '../constants/Mapping';

const paymentBaseUrl = environment.apiEndPoints.guarantorPayments.base,
  instamedPaymentSaleUrl =
    paymentBaseUrl +
    environment.apiEndPoints.guarantorPayments.endPoints.instaMedMakePayment,
  openEdgePaymentSaleUrl =
    paymentBaseUrl +
    environment.apiEndPoints.guarantorPayments.endPoints.openEdgeMakePayment,
  sendPaymentDetailEmailUrl =
    paymentBaseUrl +
    environment.apiEndPoints.guarantorPayments.endPoints.paymentConfirmation;

export const paymentSaleService = (params: {
  token: string;
  payment_method: PAYMENT_TYPES_ENUM;
  body:
    | {
        card: {
          CardNumber: string;
          Expiration: string;
        };
        amount: number;
      }
    | {
        temporary_token: string;
        amount: number;
      }
    | null;
}): Promise<any> => {
  let url = '';
  let data = {};
  if (params.payment_method === 'INSTAMED') {
    url = instamedPaymentSaleUrl;
    data = {
      data: {
        ...params.body
      }
    };
  } else if (params.payment_method === 'OPEN EDGE') {
    url = openEdgePaymentSaleUrl;
    data = {
      ...params.body
    };
  }

  return AxiosCall.post(`${url}`, {
    ...data
  });
};

export const getDetailsFromAdmin = (params: {
  clinic_group_id: string;
  clinic_id: string;
  guarantor_id?: string;
  patient_id?: string;
  payment_method?: string;
}): Promise<any> => {
  const {
    guarantor_id,
    patient_id,
    clinic_group_id,
    clinic_id,
    payment_method
  } = params;
  let url = `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/details?`;
  if (guarantor_id) {
    url += `guarantor_id=${guarantor_id}&`;
  }
  if (patient_id) {
    url += `patient_id=${patient_id}&`;
  }
  if (payment_method) {
    url += `payment_method=${payment_method}`;
  }
  return AxiosCall.get(url);
};

export const paymentPatientMiscChargeSaleService = (
  params: {
    clinic_group_id: string | number;
    clinic_id: string | number;
    guarantor_id: string | number;
    payment_type: PAYMENT_TYPES_ENUM;
    body:
      | {
          card: {
            CardNumber: string;
            Expiration: string;
          };
          amount: number;
          payment_method: string;
          patients?: any[];
        }
      | {
          temporary_token: string;
          amount: number;
          payment_method: string;
          patients?: any[];
        }
      | null;
  },
  cancelToken?: any
): Promise<any> => {
  const url = `/clinic-group/${params.clinic_group_id}/clinic/${params.clinic_id}/guarantor/${params.guarantor_id}/pay`;
  const data = {payment_type: params.payment_type, ...params.body};

  return AxiosCall.post(
    `${url}`,
    {
      ...data
    },
    cancelToken
  );
};

export const instaMedSendPaymentDetailsMail = (params: {
  token: string;
  body: {
    email: string;
    payment_id: string | number;
    invoice_number: string;
  };
}): Promise<any> => {
  return AxiosCall.post(`${sendPaymentDetailEmailUrl}`, {
    data: params.body,
    token: params.token
  });
};

export const gurantorDownloadPaymentReceipt = (params: {
  invoice_number: string;
}): Promise<any> => {
  const {invoice_number} = params;

  const url = `/guarantor/payment/${invoice_number}/download-invoice`;
  return AxiosCall.get(url);
};

export const adhocPaymentClinicSale = (params: {
  clinic_group_id: string;
  clinic_id: string;
  payment_type: PAYMENT_TYPES_ENUM;
  body:
    | {
        card: {
          CardNumber: string;
          Expiration: string;
        };
        amount: number;
      }
    | {
        temporary_token: string;
        amount: number;
      }
    | null;
}): Promise<any> => {
  const url = `/clinic-group/${params.clinic_group_id}/clinic/${params.clinic_id}/pay`;
  const data = {payment_type: params.payment_type, ...params.body};

  return AxiosCall.post(`${url}`, {
    ...data
  });
};

export const paymentPatientSaleService = (params: {
  clinic_group_id: string | number;
  payment_type: PAYMENT_TYPES_ENUM;
  body:
    | {
        card: {
          CardNumber: string;
          Expiration: string;
        };
        amount: number;
        patients?: any[];
        guarantor?: any;
      }
    | {
        temporary_token: string;
        amount: number;
        patients?: any[];
        guarantor: any;
      }
    | null;
}): Promise<any> => {
  const url = `/clinic-group/${params.clinic_group_id}/patient/create-and-pay`;
  const data = {payment_type: params.payment_type, ...params.body};

  return AxiosCall.post(`${url}`, {
    ...data
  });
};

export const publicPaymentPatientSaleService = (
  params: {
    clinic_group_id: string | number;
    clinic_short_token: string | number;
    payment_type: PAYMENT_TYPES_ENUM;
    body:
      | {
          card: {
            CardNumber: string;
            Expiration: string;
          };
          amount: number;
          patients?: any[];
          guarantor?: any;
        }
      | {
          temporary_token: string;
          amount: number;
          patients?: any[];
          guarantor: any;
          machine_id?: any;
        }
      | null;
  },
  cancelToken?: any
): Promise<any> => {
  const url = `/clinic-group/${params.clinic_group_id}/clinic/${params.clinic_short_token}/create-and-pay`;
  const data = {payment_type: params.payment_type, ...params.body};

  return AxiosCall.post(
    `${url}`,
    {
      ...data
    },
    cancelToken
  );
};

export const getCardMachineReferenceId = (params: {
  clinic_group_id: string | number;
  clinic_id: string | number;
  terminal_id: any;
}): Promise<any> => {
  const url = `clinic-group/${params.clinic_group_id}/clinic/${params.clinic_id}/card-machine/${params.terminal_id}/payment/get-reference-id`;
  return AxiosCall.get(`${url}`);
};

export const cancelCardMachineTransaction = (params: {
  clinic_group_id: string | number;
  clinic_id: string | number;
  body: {
    terminal_id: any;
    reference_id: any;
  };
}): Promise<any> => {
  const url = `/clinic-group/${params.clinic_group_id}/clinic/${params.clinic_id}/card-machine/payment/cancel`;
  const data = {...params.body};
  return AxiosCall.put(`${url}`, {
    ...data
  });
};
